import { PostTradeTooltipData } from "./type";

/**
 * Bảng mapping thứ tự và vị trí hiển thị Tooltip dựa trên key dữ liệu API.
 * Giúp quản lý vị trí (placement), ngôn ngữ hiển thị (lang) và thứ tự map cho từng phần/bản ghi.
 */
export const TOOLTIP_CONFIG = {
  // 1. Header các khối đánh giá
  setupHeader: "checklist.posttrade.setup",
  riskHeader: "checklist.posttrade.risk",
  tamlyHeader: "checklist.posttrade.tamly",

  // 2. Thứ tự items trong Setup block
  setupItems: [
    "checklist.posttrade.setup.1",
    "checklist.posttrade.setup.2",
    "checklist.posttrade.setup.3",
    "checklist.posttrade.setup.4",
  ],

  // 3. Thứ tự items trong Risk block
  riskItems: [
    "checklist.posttrade.risk.1",
  ],

  // 4. Thứ tự items trong Tâm lý (Psychology) block
  tamlyItems: [
    "checklist.posttrade.tamly.1",
    "checklist.posttrade.tamly.2",
    "checklist.posttrade.tamly.3",
    "checklist.posttrade.tamly.4",
  ],

  // 5. Timeline events
  timeline: {
    move_tp: "checklist.posttrade.timeline.move_tp",
    move_sl: "checklist.posttrade.timeline.move_sl",
    move_both: "checklist.posttrade.timeline.move_both",
    close: "checklist.posttrade.timeline.close",
  },

  // 6. Start Of Day (Mục tiêu, Sức khỏe, Bối cảnh, Setup, Kịch bản)
  startOfDay: {
    // Step 1: Risk & Goal
    riskHeader: "checklist.dauday.risk",
    riskLimit: "checklist.dauday.risk.1",
    dailyLossLimit: "checklist.dauday.risk.2",
    maxTrades: "checklist.dauday.risk.3",
    tradeReadiness: "checklist.dauday.risk.4",
    stopAtTarget: "checklist.dauday.risk.5",

    // Step 2: Health & Emotion
    suckhoeHeader: "checklist.dauday.suckhoe",
    currentEmotions: "checklist.dauday.suckhoe.2",

    // Step 3: Market Context
    boicanhHeader: "checklist.dauday.boicanh",
    structureD1: "checklist.dauday.boicanh.1",
    structureH4: "checklist.dauday.boicanh.2",
    alignmentH1M15: "checklist.dauday.boicanh.3",
    keyLevels: "checklist.dauday.boicanh.4",
    liquidityZone: "checklist.dauday.boicanh.5",
    scenarioGuess: "checklist.dauday.boicanh.6",
    marketCondition: "checklist.dauday.boicanh.7",
    tradingSession: "checklist.dauday.boicanh.8",

    // Step 5: Setup Buy
    setupBuyHeader: "checklist.dauday.setupbuy",
    buyEntryZone: "checklist.dauday.setupbuy.1",
    buyEntryMargin: "checklist.dauday.setupbuy.2",
    buyRrRatio: "checklist.dauday.setupbuy.3",
    buySl: "checklist.dauday.setupbuy.4",
    buyTp: "checklist.dauday.setupbuy.5",
    buyTrigger: "checklist.dauday.setupbuy.6",
    buyCancel: "checklist.dauday.setupbuy.7",

    // Step 6: Setup Sell
    setupSellHeader: "checklist.dauday.setupsell",
    sellEntryZone: "checklist.dauday.setupsell.1",
    sellEntryMargin: "checklist.dauday.setupsell.2",
    sellRrRatio: "checklist.dauday.setupsell.3",
    sellSl: "checklist.dauday.setupsell.4",
    sellTp: "checklist.dauday.setupsell.5",
    sellTrigger: "checklist.dauday.setupsell.6",
    sellCancel: "checklist.dauday.setupsell.7",

    // Step 7: Scenario
    kichbanHeader: "checklist.dauday.kichban",
    scenarioDesc: "checklist.dauday.kichban.desc",
    scenarioAction: "checklist.dauday.kichban.action",
    scenarioNote: "checklist.dauday.kichban.note",
    scenarioProbability: "checklist.dauday.kichban.probability",
    scenarioChart: "checklist.dauday.kichban.chart",
  }
} as const;

/**
 * Helper lấy nội dung tooltip theo key và ngôn ngữ
 */
export function getTooltipContent(
  tooltips: PostTradeTooltipData | null | undefined,
  key: string,
  lang: 'vi' | 'en' = 'vi'
): { text: string; placement: 'top' | 'bottom' | 'left' | 'right' } | null {
  if (!tooltips || !tooltips[key]) return null;
  const item = tooltips[key];
  const text = item[lang] || item.vi || item.en || "";
  if (!text) return null;
  
  const validPlacements = ['top', 'bottom', 'left', 'right'];
  const placement = validPlacements.includes(item.placement)
    ? (item.placement as 'top' | 'bottom' | 'left' | 'right')
    : 'top';

  return { text, placement };
}
